import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "./assets/bg1.png";

const FamilyDetails = ({ userId }) => {
  const schema = yup.object().shape({
    Fname: yup.string().required("Name is required"),
    Fage: yup
      .number()
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .required("Marks are required"),
    Frelation: yup.string().required("Relation is required"),
    Foccupation: yup.string().required("Occupation is required"),
    Sname: yup.string().required("Name is required"),
    Sage: yup.string().required("Age is required"),
    Srelation: yup.string().required("Relation is required"),
    Soccupation: yup.string().required("Occupation is required"),
    Sage: yup
      .number()
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .required("Marks are required"),
    // Tage: yup.number(),
    // ForthAge: yup.number(),
    // FthAge: yup.number() ,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (formData) => {
    try {
      const finalObj = { ...formData, userId };
      const response = await fetch(
        "  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/FamilyDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token")
              ? `Bearer ${localStorage.getItem("token")}`
              : null,
          },
          body: JSON.stringify(finalObj),
        }
      );

      if (!response.ok) {
        console.log("shgfjdgfjhdfkj", response);
        return toast.error(response?.statusText, {
          position: "top-center",
          transition: Slide,
        });
        // throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      toast.success("Family Details Submitted Successfully!", {
        position: "top-center",
        transition: Slide,
      });
      reset(); // Reset form after successful submission
      setTimeout(() => {
        navigate("/EnteryCandidatePortel/PreviousExperience");
      }, 2000); // 1 second delay
    } catch (error) {
      // toast.error("Error submitting form. Please try again.");

      console.log("Error:", error);
    }
  };

  return (
    <div
    className="w-full flex items-center justify-center"
    style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}
  >

      <ToastContainer transition={Slide} />
      <div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl mx-auto bg-white p-8 shadow-lg rounded-lg"
      >
         <h1 className="w-full text-3xl font-serif font-bold text-center my-6 text-indigo-600 ">
        FAMILY DETAILS
      </h1>
      <div className="border-b-2 border-indigo-400 mb-6 mx-3"></div>
        <div className="overflow-x-auto">
          <table className="table-auto w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 font-serif text-black text-center text-sm font-bold">
                  NAME
                </th>
                <th className="py-3 font-serif text-black text-center text-sm font-bold">
                  AGE
                </th>
                <th className="py-3 font-serif text-black text-center text-sm font-bold">
                  RELATION
                </th>
                <th className="py-3 font-serif text-black text-center text-sm font-bold">
                  OCCUPATION
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              <tr>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    {...register("Fname")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Age"
                    {...register("Fage")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                  {errors.Fage && (
                    <p className="text-red-500 text-sm italic">
                      {errors.Fage.message}
                    </p>
                  )}
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Relation"
                    {...register("Frelation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    {...register("Foccupation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
              </tr>
              <tr>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    {...register("Sname")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Age"
                    {...register("Sage")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                  {errors.Sage && (
                    <p className="text-red-500 text-sm italic">
                      {errors.Sage.message}
                    </p>
                  )}
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Relation"
                    {...register("Srelation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    {...register("Soccupation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
              </tr>

              <tr>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    {...register("Tname")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Age"
                    {...register("Tage")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                  {errors.Sage && (
                    <p className="text-red-500 text-sm italic">
                      {errors.Sage.message}
                    </p>
                  )}
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Relation"
                    {...register("Trelation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    {...register("Toccupation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
              </tr>

              <tr>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    {...register("ForthName")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Age"
                    {...register("ForthAge")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                  {errors.Sage && (
                    <p className="text-red-500 text-sm italic">
                      {errors.Sage.message}
                    </p>
                  )}
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Relation"
                    {...register("ForthRelation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
                <td className="py-3">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    {...register("ForthOccupation")}
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-indigo-500"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="px-8 py-2 bg-green-600 text-white rounded-md shadow hover:bg-green-700 transition-all"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
      </div>
      </div>
  );
};

export default FamilyDetails;
